<template>
  <FreeBottomSheet :name="name">
    <template #header="{ hide }">
      <FreeHeader class="p-4">
        <template #default>
          <h2 class="text-base font-medium">
            {{ t('savedPassengers.title') }}
          </h2>
        </template>
        <template #rightAction>
          <FreeCloseButton @click="hide" />
        </template>
      </FreeHeader>
    </template>
    <template #default="{ hide }">
      <div class="flex w-full flex-col items-center justify-center">
        <section
          v-if="passengers.length > 0"
          class="w-full space-y-3 px-4 pb-4"
        >
          <PassengerInfoButton
            v-for="passenger in passengers"
            :key="passenger.id"
            :passenger="passenger"
            class="p-4"
            @click="onPassengerSelected(passenger)"
          />
        </section>
        <NoSavedPassengers v-else class="pb-4" @onCloseBottomSheet="hide" />
      </div>
    </template>
  </FreeBottomSheet>
</template>

<script setup lang="ts">
  import { useI18n } from 'vue-i18n';
  import { controllerModel } from 'shared';
  import type { Accounts } from '@aviata/platform-types';

  import {
    FreeBottomSheet,
    FreeHeader,
    FreeCloseButton,
  } from '../../../shared/ui';
  import { PassengerInfoButton } from '../../../entities/booking-passenger';
  import NoSavedPassengers from './NoSavedPassengers.vue';

  const props = defineProps<{
    name: string;
    passengers: Accounts.Passenger[];
  }>();

  const emit = defineEmits<{
    onPassengerUpdate: [passenger: Accounts.Passenger];
  }>();

  const { t } = useI18n();
  const bottomSheet = controllerModel.useBottomSheet();

  function onPassengerSelected(passenger: Accounts.Passenger) {
    emit('onPassengerUpdate', passenger);
    bottomSheet.hide(props.name);
  }
</script>

<i18n src="../locales.json"></i18n>
